import { Button, TextField } from '@mui/material'
import React, { useRef, useState } from 'react'
import SendIcon from '@mui/icons-material/Send';
import Link from '@mui/material/Link';
import CallIcon from '@mui/icons-material/Call';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import GoogleIcon from '@mui/icons-material/Google';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import MenuItem from '@mui/material/MenuItem';
import './Footer.css'
import InputAdornment from '@mui/material/InputAdornment';
import AccountCircle from '@mui/icons-material/AccountCircle';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import BentoIcon from '@mui/icons-material/Bento';
import Swal from 'sweetalert2';

import { useForm, SubmitHandler } from "react-hook-form"
import { contact } from '../components/ApiService'

const Footer = React.forwardRef((props, ref) => {
    const [carType, setcarType] = useState('')

    const getCarType = (e) => {
        setcarType(e.target.value)
        console.warn(e.target.value, "vehicle Type")
    }
    const vehicleType = [
        {
            value: 'Petrol',
            label: 'Petrol',
        },
        {
            value: 'Diesel',
            label: 'Diesel',
        },
        {
            value: 'Electric',
            label: 'Electric',
        },
        {
            value: 'CNG',
            label: 'CNG',
        },
    ];

    // FORM HANDLING
    const {
        register,
        handleSubmit,
        reset,
        watch,
        formState: { errors, isSubmitting },
    } = useForm()

    async function onSubmit(data) {
        const obj = {
            firstName: data.firstName,
            lastName: data.lastName,
            emailAddress: data.email,
            phoneNumber: data.contact,
            vehicleName: data.brandName + ' ' + data.carName,
            vehicleType: data.carType,
            subject: data.subject,
            message: data.message
        }
        await contact(obj).then((res) => {
            console.log(res, "RES");
            // alert("Your request has been submitted successfully. We will get back to you soon!")
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "success",
                title: res.data.message
            });
            reset();
        }).catch((error) => {
            console.log(error, "ERR");
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: error?.response?.data.message ? error?.response?.data.message : "Something Went Wrong!"
            });
        })

        // console.log(data, "MESSAGE");
    }

    


    return (
        <>
            <div id="cntct"></div>
            <div className='footerCont' ref={ref} >
                <div className='container'>
                    <div className='row'>
                        <div className='col-xs-12 col-lg-6'>
                            <div className='contentBox'>
                                <h1>
                                    Feel Free To Ask Us Anything For Car Servicing
                                </h1>
                                <p>
                                    When you bring your vehicle to CarGenie, you can rest easy knowing that your vehicle is in professional hands. We take every possible step to ensure that your experience with us is pleasant and efficient.
                                </p>
                                <div className='openingHours'>
                                    <label>Opening Hours </label>
                                    <ul>
                                        <li><span> Mon </span> : 09:00 am - 05:00 pm </li>
                                        <li><span> Tue</span>  : 09:00 am - 05:00 pm</li>
                                        <li><span> Wed</span>  : 09:00 am - 05:00 pm</li>
                                        <li><span> Thu</span>  : 09:00 am - 05:00 pm</li>
                                        <li><span> Fri</span>  : 09:00 am - 05:00 pm</li>
                                        <li><span> Sat</span>  : 09:00 am - 06:00 pm</li>
                                        <li><span> Sun</span>  : 09:00 am - 01:30 pm</li>
                                    </ul>
                                </div>

                                <div className='footerContentBtn'>
                                    <address>
                                        <strong style={{ color: '#fff' }}>Car Genie - BM Enterprises</strong><br />
                                        1, RIC Bazar, Dunlop,<br />
                                        Bonhooghly Government Colony,<br />
                                        Kolkata, Baranagar<br />
                                        West Bengal 700108<br />
                                        <abbr title="Phone">P:</abbr> (+91) <a href='tel:7003900368' style={{color: 'grey'}}> 7003900368 </a><br />
                                        <abbr title="Email">E:</abbr> <a href="mailto:contact@cargenie.co.in" style={{color: 'grey'}}> contact@cargenie.co.in </a>
                                    </address>

                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        size="large"
                                        className='roundedBox buttonBlue'
                                        endIcon={<SendIcon />}
                                        onClick={() => window.open('https://www.google.com/maps?ll=22.650085,88.298241&z=10&t=m&hl=en&gl=IN&mapclient=embed&saddr&daddr=Car+Genie+-+BM+Enterprises,+1,+RIC+Bazar,+Dunlop,+Bonhooghly+Government+Colony,+Kolkata,+Baranagar,+West+Bengal+700108&dirflg=d', '_blank')}
                                    >
                                        Get Direction
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className='col-xs-12 col-lg-6'>
                            <form className='formBox loww' onSubmit={handleSubmit(onSubmit)}>
                                <div className='formMsgBox'>
                                    <div className='d-flex flex-column w-48'>
                                        <TextField
                                            id="First Name"
                                            label="First Name"
                                            // style={{ background: "rgb(133 129 129 / 79%)" }}
                                            {...register("firstName", {
                                                required: "First Name is required!",
                                                minLength: {
                                                    value: 4, message: "Minimum 4 characters required"
                                                },
                                            })}
                                            slotProps={{
                                                input: {
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <AccountCircle />
                                                        </InputAdornment>
                                                    ),
                                                },
                                            }}
                                            // variant="filled"
                                            className='w-100'
                                        />
                                        {errors.firstName && <span className='errorMsg'>{errors.firstName.message}</span>}
                                    </div>

                                    <div className='d-flex flex-column w-48'>
                                        <TextField
                                            id="Last Name"
                                            label="Last Name"
                                            // style={{ background: "rgb(133 129 129 / 79%)" }}
                                            {...register("lastName", {
                                                required: "Last Name is required!",
                                                minLength: { value: 4, message: "Minimum 4 characters required" }
                                            })}
                                            slotProps={{
                                                input: {
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <AccountCircle />
                                                        </InputAdornment>
                                                    ),
                                                },
                                            }}
                                            // variant="filled"
                                            className='w-100'
                                        />
                                        {errors.lastName && <span className='errorMsg'>{errors.lastName.message}</span>}
                                    </div>
                                </div>

                                <div className='formMsgBox'>
                                    <div className='d-flex flex-column w-48'>
                                        <TextField
                                            type='email'
                                            id="Email"
                                            label="Email"
                                            {...register("email",
                                                {
                                                    required: "Email is required!",
                                                    pattern: {
                                                        value: /\S+@\S+\.\S+/,
                                                        message: "Entered value does not match email format",
                                                    },
                                                }
                                            )}
                                            // style={{ background: "rgb(133 129 129 / 79%)" }}
                                            slotProps={{
                                                input: {
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <AlternateEmailIcon />
                                                        </InputAdornment>
                                                    ),
                                                },
                                            }}
                                            // variant="filled"
                                            className='w-100'
                                        />
                                        {errors.email && <span className='errorMsg'>{errors.email.message}</span>}
                                    </div>

                                    <div className='d-flex flex-column w-48'>
                                        <TextField
                                            // type='number'
                                            id="contact"
                                            label="Contact"
                                            // style={{ background: "rgb(133 129 129 / 79%)" }}
                                            {...register("contact", {
                                                required: "Contact is required!",
                                                minLength: { value: 10, message: "Minimum 10 digit required" }, maxLength: { value: 10, message: "Maximum 10 digit allowed" }
                                            })}
                                            slotProps={{
                                                input: {
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <CallIcon />
                                                        </InputAdornment>
                                                    ),
                                                },
                                            }}
                                            className='w-100'
                                        />
                                        {errors.contact && <span className='errorMsg'>{errors.contact.message}</span>}
                                    </div>
                                </div>

                                <div className='formMsgBox'>
                                    <div className='d-flex flex-column w-48'>
                                        <TextField
                                            // type='text'
                                            id="vehicle brand"
                                            label="Vehicle Brand Name"
                                            className='w-100'
                                            {...register("brandName", { required: "Please Enter Vehicle Brand Name!" })}
                                            slotProps={{
                                                input: {
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <DirectionsCarIcon />
                                                        </InputAdornment>
                                                    ),
                                                },
                                            }}
                                        />
                                        {errors.brandName && <span className='errorMsg'>{errors.brandName.message}</span>}
                                    </div>

                                    <div className='d-flex flex-column w-48'>
                                        <TextField
                                            // type='text'
                                            id="Vehicle name"
                                            label="Vehicle Name"
                                            // color="secondary"
                                            // focused
                                            // variant="filled"
                                            {...register("carName", { required: "Please Enter Vehicle Name!" })}
                                            slotProps={{
                                                input: {
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <DirectionsCarIcon />
                                                        </InputAdornment>
                                                    ),
                                                },
                                            }}
                                            className='w-100'
                                        />
                                        {errors.carName && <span className='errorMsg'>{errors.carName.message}</span>}
                                    </div>
                                </div>

                                <TextField
                                    id="outlined-select-currency"
                                    select
                                    label="Select Vehicle Type"
                                    {...register("carType", { required: "Please Enter Vehicle Type!" })}
                                    slotProps={{
                                        input: {
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <DirectionsCarIcon />
                                                </InputAdornment>
                                            ),
                                        },
                                    }}
                                    className='mb-4'
                                // style={{ background: "rgb(133 129 129 / 79%)" }}
                                >
                                    {/* {vehicleType.map((option) => ( */}
                                    <MenuItem value="">Select Car Type</MenuItem>
                                    <MenuItem value={"petrol"}> Petrol </MenuItem>
                                    <MenuItem value={"diesel"}> Diesel </MenuItem>
                                    <MenuItem value={"cng"}> CNG </MenuItem>
                                    <MenuItem value={"electric"}> Electric </MenuItem>
                                    {/* ))} */}
                                </TextField>

                                <TextField
                                    id="Subject"
                                    label="Subject"
                                    {...register("subject")}
                                    slotProps={{
                                        input: {
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <BentoIcon />
                                                </InputAdornment>
                                            ),
                                        },
                                    }}
                                    style={{ marginBottom: '20px' }}
                                />

                                <TextField
                                    id="Message"
                                    label="Message"
                                    multiline
                                    rows={4}
                                    // color="secondary"
                                    {...register("message")}
                                // style={{ background: "rgb(133 129 129 / 79%)" }}
                                />

                                <div className='btnClass mt-4'>
                                    <Button type='submit' variant="contained" color="secondary" className='roundedBox buttonBlue' endIcon={<SendIcon />} disabled={isSubmitting}>Send</Button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <section className='cto'>
                <div className='container'>
                    <div className='ctoCont'>
                        <div className='ctoLeft'>
                            <h4>
                                <img src='images/cto.png' className='img-fluid me-2' alt='carGenie' />
                                IF ANY CAR REALATED ISSUES ARE BOTHERING
                            </h4>
                            <h1> GIVE A CALL TO CARGENIE </h1>
                        </div>
                        <img src='images/mascot.png' className='img-fluid mascotCto' alt='cargenie' />
                        <div className='ctoRight'>
                            <img src='images/call.png' className='img-fluid' alt='carGenie' />
                            <div className='d-flex flex-column'>
                                <div>
                                    <p>Call Us</p>
                                    <a href='tel:917003900368'>+91-7003900368</a>
                                </div>
                                <div className='whatsappConnect'>
                                    <p>WhatsApp</p>
                                    <a href="https://api.whatsapp.com/send?phone=7003900368">
                                        Send Message <ArrowRightAltIcon />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className='footer'>
                <div className='container'>
                    <div className='row' style={{ paddingTop: "60px" }}>
                        <div className='col-lg-4 col-xs-12 logoFooter'>
                            <img src='images/logo.png' className='img-fluid' alt='LOGO' />
                            <h1>Call / WhatsApp Us Anytime</h1>
                            <Link href='7003900368'> <CallIcon /> +91-7003900368 </Link>

                            <label>Opening Hours </label>
                            <ul>
                                <li><span> Mon </span> : 09:00 am - 05:00 pm </li>
                                <li><span> Tue</span>  : 09:00 am - 05:00 pm</li>
                                <li><span> Wed</span>  : 09:00 am - 05:00 pm</li>
                                <li><span> Thu</span>  : 09:00 am - 05:00 pm</li>
                                <li><span> Fri</span>  : 09:00 am - 05:00 pm</li>
                                <li><span> Sat</span>  : 09:00 am - 06:00 pm</li>
                                <li><span> Sun</span>  : 09:00 am - 01:30 pm</li>
                            </ul>
                        </div>

                        <div className='col-lg-4 col-xs-12 linksFooter'>
                            <h3 className='footerHeading'> Our Services </h3>
                            <Link href="/" underline="none">
                                Home
                            </Link>
                            <Link href="/services" underline="none">
                                Services
                            </Link>
                            {/* <Link href="#" underline="none">
                                Gallery
                            </Link> */}
                            <Link href="/team" underline="none">
                                Our Team
                            </Link>
                            <Link href="/Privacy" underline="none">
                                Privacy Policy
                            </Link>

                            <Link href="/TermsCondition" underline="none">
                                Terms & Conditions
                            </Link>

                            <Link href="/Refund" underline="none">
                                Refund & Cancellation Policy
                            </Link>
                            <Link href="/Disclaimer" underline="none">
                                Disclaimer
                            </Link>
                            <Link href="#cntct" underline="none">
                                Contact Us
                            </Link>
                        </div>

                        <div className='col-lg-4 col-xs-12'>
                            <h3 className='footerHeading'> Find Us </h3>

                            <iframe src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d117827.17885035202!2d88.29824098341787!3d22.650084541011214!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x39f89d2400b47dc5%3A0xd3e6484c4cb27c09!2sCar%20Genie%20-%20BM%20Enterprises%2C%20126%2C%20BT%20Road%2C%20Kolkata-700108%20Dunlop%20Flyover%2C%20Bridge%2C%20near%20Dunlop%2C%20Dunlop%2C%20Saket%20Nagar%2C%20Bonhooghly%20Government%20Colony%2C%20Ashokgarh%2C%20Baranagar%2C%20West%20Bengal%20700108!3m2!1d22.6501056!2d88.3806426!5e0!3m2!1sen!2sin!4v1735757195472!5m2!1sen!2sin" width="100%" height="150" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>

                            <ul className='socialTags'>
                                <li> <a href='https://www.facebook.com/people/Car-Genie/61554109211308/' target="_blank"> <FacebookIcon color="primary" /> </a> </li>
                                <li> <a href='https://www.instagram.com/cargenieindia/?igsh=bmc2cjM3dXp1czF1#' target="_blank"> <InstagramIcon color="secondary" /> </a> </li>
                                <li> <a href='mailto:contact@cargenie.co.in' target="_blank"> <GoogleIcon color="action" /> </a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className='end'>
                <div className='container'>
                    <div className='row'>
                        <p>Copyright © 2026 BM Enterprises - All Rights Reserved.</p>
                    </div>
                </div>
            </div>
        </>
    )
})

export default Footer